import { render, staticRenderFns } from "./FieldSelectModule.vue?vue&type=template&id=4fbaa817"
import script from "./FieldSelectModule.vue?vue&type=script&lang=js"
export * from "./FieldSelectModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports